module.exports = __webpack_public_path__ + "media/offline.eaffb05c.mp4";